import {getApiStartState} from '../../../utils/reducerOperations';
export function Default() {
    return {
        responsesApi: getApiStartState(),
    };
}
